<div class="add-lead">
    <div class="ui-g-12 p-zero dialog-header">
        <div class="send-dialog-heading">Lead Source</div>
        <i class="fal fa-times fa-sm dialog-close" (click)="closeModal()"></i>
    </div>

    <div class="dialog-body">
        <div class="ui-g-12">
            <div class="ui-g-6">
                <app-input id="name" type="text" placeholder="Name*" maxLength="200" [fontSize]="14" [errorMessage]=""
                    [floatingLabel]="true" [value]="leadSource.title" (appChange)="handleChange('title',$event)">
                </app-input>
            </div>

            <div class="ui-g-6">
                <app-auto-complete id="category-name-dropdown" listId="category-name-dropdown-list" label="Category"
                    placeholder="Category" field="name" scrollHeight="95px" theme="primary" editableItemIdKey="_id"
                    editFieldLabel="Create category" [floatingLabel]="true" [hasEditableField]="true" [maxLength]="75"
                    [hasFutureSelectionField]="false" [closeOnSelection]="true" [isDropdownIconVisible]="true"
                    [hasStaticUnassignedFiled]="false" [suggestions]="categorySuggestions" [listItemFontSize]="14"
                    [fontSize]="14" [value]="leadSource.category"
                    (appUpdateItem)="onUpdateCategory($event)" (appSelect)="handleChange('category', $event)"
                    (appSave)="handleSaveCategory($event)" (appCompletedMethod)="handleSearchCategory($event)"
                    (appClear)="handleClearSearch()">
                    <ng-template let-item let-editItem="editItem" appTemplate="item">
                        <div class="tag-item flex-between-center">
                            <div>
                                <span>{{ item?.title }}</span>
                            </div>

                            <!-- <div class="tag-item-action flex-end-center">
                                <span><i class="far fa-edit pointer p-2"></i></span>
                            </div> -->
                        </div>
                    </ng-template>
                </app-auto-complete>
            </div>
        </div>

        <div class="ui-g-12 d-flex">
            <div class="ui-g-6">
                <app-switch-pill position="end" [isActive]="leadSource.showLeadSource" label="Show lead source on appointment request form"
                    [fontSize]="11" (appChange)="handleChange('showLeadSource', $event)">
                </app-switch-pill>
            </div>

            <div class="ui-g-6">
                <app-switch-pill position="end" [isActive]="leadSource.isActive" label="Active" [fontSize]="11"
                    (appChange)="handleChange('isActive', $event)">
                </app-switch-pill>
            </div>
        </div>

        <div *ngIf="isApptRequestPortalEnabled && leadSource.shortUrl && !leadSource.isGoBLeadCampaign" class="ui-g-12 input-group">
            <input type="text" class="form-control preview-link" readonly [(ngModel)]="leadSource.shortUrl"
                name="previewLink" />
            <span class="input-group-text copy-text font-white pointer bg-font-primary" (click)="copyLink()">
                <i class="fal fa-copy"></i>
                <p class="pl-2 mb-0">Copy</p>
            </span>
        </div>

    </div>

    <div class="dialog-footer flex-end-center">
        <button class="btn btn-border pointer btn-submit mr-1" (click)="closeModal()">Cancel</button>
        <button id="payment-btn-save" class="btn btn-primary btn-submit" [disabled]="false" (click)="onSubmit()">
            <span [ngClass]="isProcessing ? 'mr-2' : ''">{{isEdit ? 'Save': 'Create lead source'}}</span>
            <i *ngIf="isProcessing" class="fal fa-spinner rotate"></i>
        </button>
    </div>
</div>